import { render, staticRenderFns } from "./InsertPauseDropdown.vue?vue&type=template&id=437b7efc&scoped=true"
import script from "./InsertPauseDropdown.vue?vue&type=script&lang=js"
export * from "./InsertPauseDropdown.vue?vue&type=script&lang=js"
import style0 from "./InsertPauseDropdown.vue?vue&type=style&index=0&id=437b7efc&prod&lang=scss&scoped=true"
import style1 from "./InsertPauseDropdown.vue?vue&type=style&index=1&id=437b7efc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437b7efc",
  null
  
)

export default component.exports